export default __webpack_public_path__ + "af82ae4558df6cef5c3993a9606ec1c7.jpg";